import { environment } from "../../environments/environment";

// Kept in its own file (rather than living on VersionService, which is where
// it's mainly used) because GigyaService also needs it and VersionService
// already depends on GigyaService - importing this back from VersionService
// into GigyaService would create a circular dependency.
// see VersionService.nativeAppOidc / GigyaService.redirectToContinue.
export function isNativeAppOidcClient(): boolean {
  // /logout carries its own client_id + post_logout_redirect_uri as part of
  // RP-initiated OIDC logout (see LogoutComponent) - that's a legitimate OIDC
  // param on that route, not a signal to (re)enter the native-app OIDC login
  // flow. Without this guard, landing on /logout with the native client_id
  // would load gigya.oidc.js and cause Gigya to auto-resume/restart OIDC
  // instead of completing the logout.
  if (window.location.pathname === "/logout") {
    return false;
  }
  const params = new URLSearchParams(window.location.search);
  // ?nativeAppOidc=true forces this path regardless of client_id - useful for
  // testing on envs/clients where the real client_id above isn't registered yet.
  return params.get("client_id") === environment.nativeAppOidcClientId || params.get("nativeAppOidc") !== null;
}
